import { useQuery } from '@tanstack/react-query';
import { API_URL } from '../config/api';
import { authFetch } from '../utils/authFetch';
import { PlaidLinkToken } from '../types/plaid';

const fetchPlaidLinkToken = async () => {
    const response = await authFetch(
        `${API_URL}/integrations/plaid/link-token`,
        {method: 'POST'}
    );
    if (!response.ok) {
        throw new Error('Failed to fetch Plaid link token');
    }
    const data: PlaidLinkToken = await response.json();
    return data.linkToken;
};

export const usePlaidLinkToken = (enabled: boolean) => {
    return useQuery({
        queryKey: ['plaid-link-token'],
        queryFn: fetchPlaidLinkToken,
        enabled,
        refetchOnWindowFocus: false,
        retry: 1,
    }); 
};